import Config from 'conf';
import bindSocketEvents from './binds';

export default socketMiddleware => {
    bindSocketEvents(socketMiddleware);
    let socketEmit = socketMiddleware.socketEmit.bind(socketMiddleware);
    let socketOn = socketMiddleware.socketOn.bind(socketMiddleware);
    return {
        goProd: box_mac => {
            return new Promise((resolve, reject) => {
                let goProductionFeedback = args => {
                    if (args.box_mac === box_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('goProductionFeedback', goProductionFeedback);
                        if (args.success) return resolve();
                        else return reject(new Error(args.error));
                    }
                };

                socketOn('goProductionFeedback', goProductionFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('goProductionFeedback', goProductionFeedback);
                    reject(new Error('timeout'));
                }, 3 * 60 * 1000);

                socketEmit('goProduction', { box_mac });
            });
        },
        testBox: box_mac => {
            return new Promise((resolve, reject) => {
                let testBoxFeedback = args => {
                    if (args.box_mac === box_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('testResult', testBoxFeedback);
                        return resolve();
                    }
                };

                socketOn('testResult', testBoxFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('testBoxFeedback', testBoxFeedback);
                    reject(new Error('timeout'));
                }, 3 * 60 * 1000);

                socketEmit('testBox', { box_mac });
            });
        },
        loadEnv: box_mac => {
            return new Promise((resolve, reject) => {
                let loadEnvFeedback = args => {
                    if (args.box_mac === box_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('loadEnvFeedback', loadEnvFeedback);
                        if (args.success) return resolve();
                        else return reject(new Error(args.error));
                    }
                };

                socketOn('loadEnvFeedback', loadEnvFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('loadEnvFeedback', loadEnvFeedback);
                    reject(new Error('timeout'));
                }, 3 * 60 * 1000);

                socketEmit('loadEnv', { box_mac });
            });
        }
    };
};



// WEBPACK FOOTER //
// ./environments/testbench/eventsSocket/Boxes/index.js